/**
 * The single sentence shown when a recognitions fetch fails with rows already on screen -- reused
 * verbatim by both `RecognitionList.tsx` (Overview) and `UserRecognitionsContainer.tsx` (profile),
 * hoisted here for the same reason `atFeedCap.ts`'s own `feedCapMessage` is: two verbatim-identical
 * strings free to drift the moment either copy is edited alone. Its own module, not folded into
 * `atFeedCap.ts`, because this is a load-FAILURE concern, not a row-cap one -- `atFeedCap.ts` is named
 * for, and already scoped to, the cap predicate/constant/copy trio (mirrors this folder's own
 * `hasMore.ts` convention of one small module per concern, each with its own test file).
 *
 * feed-inline-failure-plan.md (🚨 SUPERSEDED design): an earlier version picked between two sentences
 * by reading `filter.page` (`page === 0` meant the last request was a REPLACE, so what's on screen is
 * stale; `page > 0` meant an APPEND, so what's on screen is a correct but incomplete prefix). Review
 * found that discriminator unsound three ways: (1) it read the CURRENT filter, not the page of the
 * request that actually failed, and neither `setReceivedFilter` nor `setSentFilter` clears the
 * load-failed flag -- a failed append at page 3 followed by a period/search/core-value change
 * re-renders with `page: 0` and flips the message to "couldn't refresh" while that refresh is still
 * in flight, asserting a failure for a request that has not resolved; (2) `page === 0` disagreed with
 * the saga's own `is_clear: !payload.page` on a missing `page`; (3) on the profile the "replace" arm
 * could fire with zero rows on screen, where "may be out of date" is nonsensical over an empty table
 * (`UserRecognitionsContainer.tsx` now gates this message on `rows.length > 0` explicitly for that
 * reason).
 *
 * One sentence, true either way, removes the need to discriminate at all: "incomplete" covers a
 * failed append (a correct prefix, missing its tail); "out of date" covers a failed replace (a full
 * but stale list). Both are just "what's shown may not be trustworthy right now."
 */
export const loadFailedMessage = "We couldn't load your recognitions — what's shown may be incomplete or out of date.";
